var _defs, _polygon, _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _circle, _path5, _polygon2, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 296.28 252.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-7{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-7{stroke:#797d79;}.cls-2,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3,.cls-4{stroke-width:4.71px;}.cls-3,.cls-4,.cls-5{fill:none;}.cls-3,.cls-5,.cls-7{stroke-miterlimit:10;}.cls-5{stroke-width:4.52px;}.cls-6{fill:#797d79;}.cls-7{stroke-width:4px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "235.02 249.75 61.47 249.75 61.47 239.99 88.22 231.78 90.42 220.83 90.42 205.96 205.45 206.1 205.59 226.27 217.43 234.64 235.47 239.83 235.02 249.75"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.36,
    y: 28.24,
    width: 291.56,
    height: 178.48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.36,
    y: 28.24,
    width: 291.56,
    height: 178.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.38,254.45v-18.8H91.81v18.8c0,9.11-29,15.33-29,15.33H236.37S207.38,263.28,207.38,254.45Z",
    transform: "translate(-1.7 -28.93)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 61.13,
    y: 240.84,
    width: 174,
    height: 9.52
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.32,
    y: 35.96,
    width: 274.32,
    height: 144.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.72,222.07a5.36,5.36,0,0,1-5.35,5.36H141.3a5.35,5.35,0,0,1-5.35-5.36h0a5.34,5.34,0,0,1,5.35-5.35h17.07a5.36,5.36,0,0,1,5.35,5.35Z",
    transform: "translate(-1.7 -28.93)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.8,132.5A39.26,39.26,0,1,1,73.54,93.24,39.26,39.26,0,0,1,112.8,132.5Z",
    transform: "translate(-1.7 -28.93)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90,136.47a11.16,11.16,0,0,0-6.33-3.56,9.81,9.81,0,0,0,4.3-2.66,9,9,0,0,0,2.21-6.08,9.27,9.27,0,0,0-3.09-7.08,11.12,11.12,0,0,0-6.31-2.7v-3.63H76.38v3.47H71.91v-3.47H67.55v3.47H55.09v39.92H67.55v3.47h4.36v-3.47h4.47v3.47h4.36v-3.86l1.18-.15a13,13,0,0,0,4.68-1.31,10.61,10.61,0,0,0,4-3.92A10.89,10.89,0,0,0,92,142.8,9.73,9.73,0,0,0,90,136.47ZM67.54,122.32H73a6.12,6.12,0,0,1,3.94,1A3.42,3.42,0,0,1,78.05,126a3.65,3.65,0,0,1-1.13,2.88q-1.14,1-4,1H67.54Zm0,23.25v-8.08H73.8q3.24,0,4.53,1.08a3.48,3.48,0,0,1,1.3,2.84,3.83,3.83,0,0,1-1.31,3c-.87.75-2.37,1.12-4.49,1.12Z",
    transform: "translate(-1.7 -28.93)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 193.52,
    cy: 54.32,
    r: 23.39,
    transform: "translate(94.49 201.26) rotate(-76.72)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.86,67.63V64.35a9.44,9.44,0,0,1-5-1.42l.78-2.17a8.71,8.71,0,0,0,4.67,1.39c2.3,0,3.85-1.33,3.85-3.18s-1.26-2.88-3.66-3.85c-3.3-1.3-5.35-2.79-5.35-5.61s1.92-4.73,4.9-5.22V41h2v3.14a8.6,8.6,0,0,1,4.21,1.14l-.81,2.13a7.92,7.92,0,0,0-4.08-1.1c-2.5,0-3.44,1.49-3.44,2.79,0,1.68,1.2,2.53,4,3.69,3.34,1.37,5,3,5,5.94,0,2.56-1.78,5-5.12,5.51v3.37Z",
    transform: "translate(-1.7 -28.93)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "255.46 17.24 237.98 22.89 243 27.89 206.51 63.39 175.41 56.14 131.71 107.02 136.15 110.58 177.32 61.49 208.14 69.37 245.59 30.48 250.1 34.98 255.46 17.24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.59,188.3V82.54A2.65,2.65,0,0,0,263,79.9H237.23a2.65,2.65,0,0,0-2.64,2.64V188.3h-3.33V112.16a2.64,2.64,0,0,0-2.64-2.64H202.9a2.64,2.64,0,0,0-2.64,2.64V188.3h-3.34V133.22a2.64,2.64,0,0,0-2.64-2.64H168.56a2.65,2.65,0,0,0-2.64,2.64V188.3h-3.33V158.23a2.65,2.65,0,0,0-2.64-2.64H134.23a2.65,2.65,0,0,0-2.64,2.64V188.3H121.44v10.17h154.7V188.3Z",
    transform: "translate(-1.7 -28.93)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/sell.9715c43d59c1f59df78e518ca860e027.svg";
export { ForwardRef as ReactComponent };